import { configureStore } from '@reduxjs/toolkit';
import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';
import { persistStore } from 'redux-persist';
import {
  affiliateApi,
  agentApi,
  lifeApi,
  paymentApi,
  tokenApi,
  adminApi,
} from '../apis';
import { applicationReducer } from './application';

export const store = configureStore({
  reducer: {
    [lifeApi.reducerPath]: lifeApi.reducer,
    [adminApi.reducerPath]: adminApi.reducer,
    [paymentApi.reducerPath]: paymentApi.reducer,
    [agentApi.reducerPath]: agentApi.reducer,
    [affiliateApi.reducerPath]: affiliateApi.reducer,
    [tokenApi.reducerPath]: tokenApi.reducer,
    [applicationReducer.reducerPath]: applicationReducer.reducer,
  },
  middleware(getDefaultMiddleware) {
    return getDefaultMiddleware({
      serializableCheck: false,
    }).concat(
      lifeApi.middleware,
      paymentApi.middleware,
      agentApi.middleware,
      affiliateApi.middleware,
      adminApi.middleware,
      tokenApi.middleware,
    );
  },
  devTools: process.env.NODE_ENV === 'development',
});

export const persistor = persistStore(store);

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch;

// Use throughout your app instead of plain `useDispatch` and `useSelector`
export const useAppDispatch: () => AppDispatch = useDispatch;
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
